export const environment = {
  production: true,
  config: {
    DATA_API_URL: 'https://mcapi.ppm.org',
    STAFF_PHOTO_URL: 'https://storage.googleapis.com/ppm-profile-photos/staff/',
    MCAPI_KEY: 'PLTxAQ5jS7qTSdKQf71nUCs4JKzeFNRVeqbKrQ8EFV1ESGTIi9ch6rZAW3XI0Nea',
    MC_HOST: 'https://mc.ppm.org',
    PELICAN_ACCOUNT_URL: 'https://account.ppm.org',
    GOOGLE_SIGN_IN_CLIENT_ID: '450245815385-c480ig9ebqk72v08475v6c39p2ekdq1a.apps.googleusercontent.com',
  },
};
